export function KpiCard({ label, value, unit, accent = "black", testid, icon: Icon }) {
    // Editorial monochrome — value is always near-black. `accent` prop is
    // retained for API compatibility but only shifts to a warning tint when
    // caller explicitly asks for an alert state.
    const accentMap = {
        orange: "text-[#F97316]",
        green: "text-zinc-900",
        black: "text-zinc-900",
        red: "text-red-600",
    };
    return (
        <div className="bg-white border border-zinc-200 rounded-2xl p-5 flex flex-col gap-3 hover:border-zinc-300 transition-colors" data-testid={testid}>
            <div className="flex items-center justify-between">
                <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500">{label}</div>
                {Icon && <Icon className="w-4 h-4 text-zinc-400" />}
            </div>
            <div className="flex items-baseline gap-2">
                <div className={`text-5xl font-dot leading-none tracking-tight ${accentMap[accent]}`}>{value}</div>
                {unit && <div className="text-xs font-mono text-zinc-500">{unit}</div>}
            </div>
        </div>
    );
}
